import React from 'react'
import Button from '@material-ui/core/Button'
import PropTypes from 'prop-types'

export const BreakPrompt = ({ classes, startBreakTimer }) => (
  <div>
    <h1 className={classes.centered}>Time for a break</h1>
    <Button
      className={classes.buttonBreaktime}
      variant="contained"
      onClick={() => startBreakTimer('Chill')}>
      Chill
    </Button>
    <Button
      className={classes.buttonBreaktime}
      variant="contained"
      onClick={() => startBreakTimer('Exercise')}>
      Exercise
    </Button>
    <Button
      className={classes.buttonBreaktime}
      variant="contained"
      onClick={() => startBreakTimer('Meditate')}>
      Meditate
    </Button>
  </div>
)

BreakPrompt.propTypes = {
  classes: PropTypes.object,
  startBreakTimer: PropTypes.func.isRequired,
}

export default BreakPrompt



// WEBPACK FOOTER //
// ./src/components/BreakPrompt/BreakPrompt.js